import { UseMutationResult } from '@tanstack/react-query'

import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { deleteInstallation } from '../api/installation-details.api'

interface UseDecommissionInstallationParams {
  onSuccess?: (vars: DeleteInstallationVariables) => void
  onError?: (vars: DeleteInstallationVariables) => void
}

interface DeleteInstallationVariables {
  installationId?: number | string
}

type UseDeleteInstallationReturnType = (data: UseDecommissionInstallationParams) => UseMutationResult<null, unknown, DeleteInstallationVariables>

export const useDeleteInstallation: UseDeleteInstallationReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  const mutationResult = usePortalMutation({
    mutationFn: (vars: DeleteInstallationVariables) => deleteInstallation(vars.installationId, authFetch),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (_, vars) => onError?.(vars),
  })

  return mutationResult
}
